<div #mapWrapper class="radar-map-wrapper">
  <div #radarMapContainer class="radar-map-container"></div>
  @if (showMapControls && isBrowser) {
    <div class="radar-map-controls">
      @if (showFullscreenControl) {
        <button
          type="button"
          class="radar-fullscreen-btn"
          (click)="toggleFullscreen()"
          [attr.aria-label]="isFullscreen ? 'Exit fullscreen' : 'Fullscreen'"
        >
          <img [src]="isFullscreen ? exitFullscreenIconUrl : fullscreenIconUrl" alt="" width="18" height="18" />
        </button>
      }
    </div>
  }
</div>
